import HttpRequest from "@/api/axios";
import moment    from 'moment'

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
export default {
    h5login(data) {
        return axios.request({
            url: "user/login-wx",
            method: "post",
            data
        });
    },
    list(data) {
        return axios.request({
            url: "organization/wmatrix",
            method: "get",
            params: data
        });
    },
    orglist(data) {
        return axios.request({
            url: "organization",
            method: "get",
            params: data
        });
    },
    plist(data) {
        return axios.request({
            url: "group/list",
            method: "get",
            params: data
        });
    },
    area(data) {
        return axios.request({
            url: "group/area",
            method: "get",
            params: data
        });
    },
    join(data) {
        return axios.request({
            url: "group/join",
            method: "post",
            data
        });
    },
    matchupdate(data) {
        return axios.request({
            url: "match/update-data",
            method: "post",
            data
        });
    },
    topicupdate(data) {
        return axios.request({
            url: "topic/update-data",
            method: "post",
            data
        });
    },
    grouplist(data) {
        return axios.request({
            url: "group/alliance",
            method: "get",
            params: data
        });
    },
    groupdetail(data) {
        return axios.request({
            url: "group/alliance-detail",
            method: "get",
            params: data
        });
    },
};